module.exports = __webpack_public_path__ + "static/media/black_pawn.608767a5.svg";